import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "HeaderQuoteDetail",
    initialState: {
        setHeaderQuoteDetail: {
            data: []
        }
    },
    reducers: {
        setHeaderQuoteDetail: {
            reducer: (state, action) => {
                state.setHeaderQuoteDetail.data = action.payload.data;
            },
        },
    }
});

export let { setHeaderQuoteDetail } = slice.actions;

export default slice.reducer;
